import { createPinia } from 'pinia';
const store = createPinia();

export * from './modules';
export default store;
